import {SVGProps} from 'react';

const ZipFileLarge = (props: SVGProps<SVGSVGElement>) => (
    <svg
        height="100%"
        id="zip-file-large"
        viewBox="0 0 150 150"
        width="100%"
        {...props}
    >
        <path
            d="M39.8437 138.281H110.156C117.923 138.281 124.219 131.985 124.219 124.219V49.2188V25.7812C124.219 18.0147 117.923 11.7188 110.156 11.7188H39.8438C32.0772 11.7188 25.7812 18.0147 25.7812 25.7812V124.219C25.7812 131.985 32.0772 138.281 39.8437 138.281Z"
            fill="#DEDEDE"
            stroke="#818181"
            strokeWidth="7.03125"
        />
        <rect
            fill="#3C3C3C"
            height="46.875"
            rx="9.375"
            width="84.375"
            x="9.375"
            y="79.6875"
        />
        <path
            d="M18.75 118.787H42.2127V112.711H27.6695V112.566L41.7595 93.8622V89.0625H18.9766V95.1393H32.8812V95.2835L18.75 113.988V118.787Z"
            fill="#FDFDFD"
        />
        <path
            d="M47.4746 118.787H55.0345V89.0625H47.4746V118.787Z"
            fill="#FDFDFD"
        />
        <path
            d="M60.8114 118.787H68.3714V110.074H73.48C80.113 110.074 84.3977 105.995 84.3977 99.63V99.5888C84.3977 93.2236 80.113 89.0625 73.48 89.0625H60.8114V118.787ZM71.6673 94.8509C74.8602 94.8509 76.7553 96.4989 76.7553 99.5888V99.63C76.7553 102.72 74.8602 104.388 71.6673 104.388H68.3714V94.8509H71.6673Z"
            fill="#FDFDFD"
        />
        <path
            d="M83.8698 25.9633L85.7995 16.3152C86.334 13.6426 88.6807 11.7188 91.4062 11.7188C94.1318 11.7188 96.4785 13.6426 97.013 16.3152L98.9427 25.9633C99.8938 30.7191 96.2563 35.1562 91.4062 35.1562C86.5562 35.1562 82.9187 30.7191 83.8698 25.9633Z"
            fill="#FDFDFD"
            stroke="#818181"
            strokeWidth="7.03125"
        />
        <path
            d="M91.4062 44.5312V49.2188"
            stroke="#818181"
            strokeLinecap="round"
            strokeWidth="7.03125"
        />
        <path
            d="M91.4062 63.2812V67.9688"
            stroke="#818181"
            strokeLinecap="round"
            strokeWidth="7.03125"
        />
    </svg>
);

export default ZipFileLarge;
